const recommendation = [
  // {
  //   name: 'Suelen Arruda', 
  //   message: '"Além de ser uma pessoa talentosíssima e com habilidades técnicas inúmeras, nos presentou com seu carisma, tranquilidade, equilíbrio. Sempre pronto a ajudar."', 
  //   social: 'https://www.linkedin.com/in/suelen-arruda/'
  // },
];

export default recommendation;